export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[];
  };
}
const result: PossibleTypesResultData = {
  possibleTypes: {
    Actionable: [
      "BookAppointmentActionable",
      "CompleteHPIActionable",
      "CompleteLoggingActionable",
      "EducationalMaterialActionable",
      "FollowUpAppointmentActionable",
      "GenericActionable",
      "PayBillActionable",
      "ReferralActionable",
      "RxFillActionable",
    ],
    AdjustBillToSelfPayRateError: ["BillNotFound", "IllegalBillState", "Unauthorized"],
    AdjustBillablesForBillError: ["BillNotFound", "IllegalBillState", "Unauthorized"],
    ApplyCaseRateError: ["IllegalBillState", "InvalidCaseRate", "Unauthorized"],
    ApptSharedItem: [
      "EntityNote",
      "EntityOrder",
      "LabRequest",
      "LabResult",
      "MedicalDocument",
      "MedicalImageRequest",
      "MedicalImageRequestResult",
    ],
    ApptStepMetadata: ["AdditionalVisitChargesStepMetadata", "PaymentStepMetadata"],
    BatchCreateProviderDxSuggestionsError: [
      "InvalidProviderDxSuggestionInput",
      "SuggestionAlreadyExists",
      "Unauthorized",
    ],
    BillHeartbeatResponse: ["BillLock", "BillLockNotFound"],
    BillLog: [
      "BillCreatedLog",
      "BillNote",
      "BillRefund",
      "BillStatusChange",
      "Installment",
      "PatientPayment",
      "PaymentReport",
      "ReverseWriteOffLog",
      "WriteOff",
    ],
    BillResponsibleParty: [
      "InsuranceResponsibleParty",
      "OrganizationResponsibleParty",
      "PatientResponsibleParty",
    ],
    BillTagMetadata: ["BillTagMetadataCommon", "BillTagMetadataSentToDebtCollection"],
    CarbyActionSuggestionItem: ["CarbyActionLabTestSuggestionItem", "CarbyActionRxSuggestionItem"],
    ChangeRenderingProviderOnBillError: [
      "BillNotFound",
      "InvalidRenderingProvider",
      "Unauthorized",
    ],
    ChangeSupervisingProviderOnAppointmentError: [
      "ApptNotFound",
      "InvalidSupervisingProvider",
      "Unauthorized",
    ],
    Connection: [
      "ActionablesConnection",
      "AddressEntityConnection",
      "AppointmentsConnection",
      "ApptContractedPayerConnection",
      "ApptSharedResultConnection",
      "AuditLogConnection",
      "AutomatedFollowUpConnection",
      "BatchPaymentClaimsConnection",
      "BatchRefundClaimsConnection",
      "BillExecutionJobsConnection",
      "BillingQueueConnection",
      "BillsConnection",
      "BookableLocationImagesConnection",
      "BookableLocationsConnection",
      "CancelPrescriptionRequestConnection",
      "CardScansAndMedicalImagesConnection",
      "CarePractitionerConnection",
      "CaseReportsConnection",
      "CasesConnection",
      "CovidHomeTestKitOrdersConnection",
      "CovidTestsConnection",
      "CptMaxUnitsConnection",
      "DeviceConnection",
      "DiagnosisConnection",
      "DoctorLocationShiftConnection",
      "DocumentsConnection",
      "DrugFormConnection",
      "DrugRouteConnection",
      "EcqmExportConnection",
      "EcqmImportConnection",
      "EducationalMaterialConnection",
      "EmployeeConnection",
      "EntityOrderConnection",
      "FilledPrescriptionConnection",
      "HealthConcernConnection",
      "InPersonFollowUpConnection",
      "InsuranceCardScansConnection",
      "InsuranceClaimsConnection",
      "InsuranceConnection",
      "LabRequestConnection",
      "LabResultsConnection",
      "LabTestPanelsConnection",
      "LocationStaffingLevelConnection",
      "MDEventConnection",
      "MedicalImageRequestConnection",
      "MedicationConnection",
      "MedicationGroupConnection",
      "MessageConnection",
      "NDCConnection",
      "NonProcessingRulesConnection",
      "OrganizationConnection",
      "OrganizationGroupsConnection",
      "OrganizationInvoiceConnection",
      "OrganizationInvoiceWithPeriodConnection",
      "OrganizationMembersConnection",
      "PatientIdentificationCardScansConnection",
      "PatientLogsConnection",
      "PaymentMethodConnection",
      "PermissionConnection",
      "PracticeAppointmentReasonConnection",
      "PracticesConnection",
      "PrescriptionChangeRequestConnection",
      "PrescriptionConnection",
      "PrescriptionRenewalRequestConnection",
      "ProblemConnection",
      "ProcessingRuleCheckpointConnection",
      "ProcessingRuleConnection",
      "ProcessingRuleDailyMetricsConnection",
      "ProviderAdjustmentConnection",
      "ProviderDxSuggestionConnection",
      "ReferralSuggestionConnection",
      "RegionalPractitionerConnection",
      "ReportedMedicationConnection",
      "RuleExecutionConnection",
      "ScratchpadConnection",
      "SdohConditionsConnection",
      "SearchBatchPaymentClaimsConnection",
      "SearchBatchPaymentsConnection",
      "SearchBatchRefundClaimsConnection",
      "SearchBatchRefundsConnection",
      "SearchRegionConnection",
      "SpecialtyConnection",
      "StaffingLevelConnection",
      "StaffingLevelShiftConnection",
      "StaffingRoleConnection",
      "TimelyFilingLimitConnection",
      "TransactionsConnection",
      "UserGroupConnection",
      "UsersConnection",
      "VaccineConnection",
    ],
    CopyRuleBetweenPracticesError: [
      "InvalidRuleName",
      "RuleNotFound",
      "RuleToCopyAlreadyExists",
      "Unauthorized",
    ],
    CreateCptMaxUnitsError: ["CptMaxUnitsAlreadyExists", "InvalidCptMaxUnitsInput", "Unauthorized"],
    CreateTimelyFilingLimitError: ["InvalidTimelyFilingLimitInput", "Unauthorized"],
    DeleteCptMaxUnitsError: ["CptMaxUnitsNotFound", "Unauthorized"],
    DeleteProviderDxSuggestionError: ["ProviderDxSuggestionNotFound", "Unauthorized"],
    DeleteTimelyFilingLimitError: ["TimelyFilingLimitNotFound", "Unauthorized"],
    DmePaymentParserErrorContainer: [
      "DmePaymentParserCSVLevelError",
      "DmePaymentParserRowLevelError",
    ],
    DropBillFromDebtCollectionError: ["BillNotFound", "IllegalBillState", "Unauthorized"],
    FieldInsight: ["ChoiceInsights"],
    Insurance: ["HealthInsurance", "MedicalInsurance", "OtherInsurance"],
    LinkBCBSAccountError: ["Unauthorized"],
    LockBillError: ["AlreadyLockedByAnotherUser", "Unauthorized"],
    MarkBillAsFullyPaidError: ["BillNotFound", "IllegalBillState", "Unauthorized"],
    MutationResponse: [
      "AddApptSharedResultsResponse",
      "AddApptStepSkipResponse",
      "AddAutomatedFollowUpsResponse",
      "AddBillsToQueueResponse",
      "AddCarePractitionerToPatientsHealthTeamResponse",
      "AddClaimsToBatchPaymentResponse",
      "AddClaimsToBatchRefundResponse",
      "AddDiagnosisResponse",
      "AddDocumentResponse",
      "AddDraftLocationStaffingLevelScheduleResponse",
      "AddEducationalMaterialResponse",
      "AddEducationalMaterialsResponse",
      "AddEntityNoteResponse",
      "AddEntityOrdersResponse",
      "AddHealthConcernResponse",
      "AddInPersonFollowUpsResponse",
      "AddLabRequestsResponse",
      "AddMedicalDocumentsResponse",
      "AddMedicalImageRequestsResponse",
      "AddMedicationAllergiesResponse",
      "AddMedicationGroupStatusResponse",
      "AddMedicationStatusesResponse",
      "AddPrescriptionsResponse",
      "AddProblemFromDiagnosisResponse",
      "AddProblemListStatusesResponse",
      "AddProblemResponse",
      "AddReferralSuggestionsResponse",
      "AddSdohConditionResponse",
      "AddUserGroupPermissionsResponse",
      "AddUserPermissionsResponse",
      "AdjustBillToSelfPayRateResponse",
      "AdjustBillablesForBillResponse",
      "ApplyCaseRateResponse",
      "ApproveOrdersResponse",
      "ApproveRuleResponse",
      "AttachDataMotionToPatientResponse",
      "AttachFloatingPatientPaymentToBillResponse",
      "AuthenticateLoginCodeResponse",
      "AuthenticatePasswordlessOrganizationAdminResponse",
      "AuthenticatePasswordlessResponse",
      "BatchCreateProviderDxSuggestionsResponse",
      "BatchCreateTimelyFilingLimitsResponse",
      "CancelBillInstallmentsResponse",
      "CancelCurrentReaderActionResponse",
      "ChangeRenderingProviderOnBillResponse",
      "ChangeSupervisingProviderOnAppointmentResponse",
      "ChargePatientCreditCardForBillResponse",
      "CompleteActionableResponse",
      "CompleteBillReviewResponse",
      "CopyRuleBetweenPracticesResponse",
      "CorrectClaimResponse",
      "CreateAuditEventResponse",
      "CreateBillInstallmentsResponse",
      "CreateBillNoteResponse",
      "CreateBillableResponse",
      "CreateBillingQueueResponse",
      "CreateCarePractitionerAndAddToPatientsHealthTeamResponse",
      "CreateCarePractitionerResponse",
      "CreateClaimSubmissionResponse",
      "CreateConditionResponse",
      "CreateConsentSignatureResponse",
      "CreateCptMaxUnitsResponse",
      "CreateEcqmImportResponse",
      "CreateManualPaymentReportResponse",
      "CreatePatientLogResponse",
      "CreateProcessingRuleResponse",
      "CreateRuleResponse",
      "CreateSetupIntentResponse",
      "CreateStripeAccountLinkResponse",
      "CreateStripeAccountResponse",
      "CreateTimelyFilingLimitResponse",
      "DeclareNoPatientHealthTeamMemberOfTypeExistsResponse",
      "DeleteApptStepSkipResponse",
      "DeleteAutomatedFollowUpResponse",
      "DeleteBatchPaymentAndReportsResponse",
      "DeleteBatchRefundAndReportsResponse",
      "DeleteBillingQueueResponse",
      "DeleteBloodPressureCuffSizeResponse",
      "DeleteCptMaxUnitsResponse",
      "DeleteDiagnosisResponse",
      "DeleteDoctorLocationShiftResponse",
      "DeleteDrugAdministrationResponse",
      "DeleteEducationalMaterialResponse",
      "DeleteEntityNoteResponse",
      "DeleteEntityOrderResponse",
      "DeleteHealthConcernResponse",
      "DeleteInPersonFollowUpResponse",
      "DeleteLabRequestResponse",
      "DeleteLabResultResponse",
      "DeleteLocationStaffingLevelResponse",
      "DeleteMedicalDocumentResponse",
      "DeleteMedicalImageRequestResponse",
      "DeleteMedicalImageResponse",
      "DeleteMedicalImageResultResponse",
      "DeleteMedicationAllergyResponse",
      "DeletePatientLogResponse",
      "DeletePaymentReportResponse",
      "DeletePrescriptionResponse",
      "DeleteProblemListStatusResponse",
      "DeleteProblemResponse",
      "DeleteProviderAdjustmentResponse",
      "DeleteProviderDxSuggestionResponse",
      "DeleteReferralSuggestionResponse",
      "DeleteRuleResponse",
      "DeleteSdohConditionResponse",
      "DeleteStaffingLevelShiftResponse",
      "DeleteTimeLogResponse",
      "DeleteTimelyFilingLimitResponse",
      "DeleteUnbilledBillableResponse",
      "DeleteVirtualVisitPodResponse",
      "DismissActionableResponse",
      "DropBillFromDebtCollectionResponse",
      "EvaluateEntityRulesResponse",
      "FaxReferralPacketResponse",
      "FinalizeBillAndInvoicePatientResponse",
      "GenerateAndSaveReferralPacketResponse",
      "GenerateCCDAResponse",
      "GenerateDmePaymentsFileUploadUrlResponse",
      "GenerateDocumentUploadUrlResponse",
      "GenerateInvoicesResponse",
      "GenerateOccHealthInvoicesResponse",
      "GenerateOrganizationInvoiceResponse",
      "GenerateReferralPacketResponse",
      "GenerateRpmBillingFileUploadUrlResponse",
      "GenerateSaveAndFaxReferralPacketResponse",
      "GetOrCreateCcdaViewPreferencesResponse",
      "LinkBCBSAccountResponse",
      "LockBillResponse",
      "MarkBillAsFullyPaidResponse",
      "MarkInsuranceCoverageInactiveResponse",
      "MoveAppointmentItemResponse",
      "NotifyPatientForBillResponse",
      "OrganizationAdminResponse",
      "OrganizationChangeMembersResponse",
      "OrganizationCreationResponse",
      "OrganizationMemberChangeResponse",
      "OverrideBillInstallmentsResponse",
      "PauseBillResponse",
      "PayBillAsGuestWithSavedMethodResponse",
      "PayOrganizationInvoiceWithACHResponse",
      "PayOrganizationInvoiceWithCheckResponse",
      "PayOrganizationInvoiceWithCreditCardResponse",
      "PaymentIntentCancelResponse",
      "PaymentIntentCreateAndSendToReaderResponse",
      "PaymentIntentCreateForGuestResponse",
      "PaymentIntentCreateResponse",
      "PaymentMethodsSyncResponse",
      "PostCareCreditPaymentForBillResponse",
      "PostCashPaymentForBillResponse",
      "PostCheckPaymentForBillResponse",
      "PostDmePaymentsFromUploadResponse",
      "PostRpmBillingFromUploadResponse",
      "PublishCarePlanResponse",
      "PublishLabResultsResponse",
      "PublishLocationStaffingLevelScheduleResponse",
      "RebillClaimResponse",
      "RecalculateSplitResponse",
      "RecordRefundForCashOrCheckPaymentResponse",
      "RecordRefundForSuccessfullyDisputedChargeResponse",
      "RefundCreditCardPatientPaymentResponse",
      "RemoveBillsFromQueueResponse",
      "RemovePatientFromOrganizationResponse",
      "RemovePaymentMethodResponse",
      "RemoveSecondaryTertiaryInsuranceResponse",
      "RemoveUserGroupPermissionsResponse",
      "RemoveUserPermissionsResponse",
      "ReorderBillInsurancesResponse",
      "ReorderProcessingRulesResponse",
      "ReverseBillWriteOffResponse",
      "ReverseCaseRateResponse",
      "ReviewDiagnosisAssociationResponse",
      "SaveConsentFormResponse",
      "SaveOrderDxAssociationsResponse",
      "SendLoginCodeResponse",
      "SendOrganizationInvoiceGeneratedEmailResponse",
      "SendPasswordlessLoginResponse",
      "SendPasswordlessLoginToOrganizationAdminResponse",
      "SendPasswordlessLoginToPatientResponse",
      "SetAppointmentHpiResponse",
      "SetBillInsuranceResponse",
      "SetBillResponsibilityToInsuranceResponse",
      "SetBillResponsibilityToOrganizationResponse",
      "SetBillResponsibilityToPatientResponse",
      "SetBloodPressureCuffSizeResponse",
      "SetDefaultPaymentMethodResponse",
      "SetLabRequestDispositionStatusResponse",
      "SetProcessingRuleIsEnabledResponse",
      "SnoozeActionableResponse",
      "SoftDeleteApptSharedResultResponse",
      "StartEcqmExportResponse",
      "StartEcqmImportResponse",
      "TagInsuranceUpdatedResponse",
      "UndeletePaymentReportResponse",
      "UnlockBillResponse",
      "UnpauseBillResponse",
      "UpdateAppointmentResponsiblePartyResponse",
      "UpdateAppointmentSpecialtyResponse",
      "UpdateAutomatedFollowUpResponse",
      "UpdateBillPlaceOfServiceResponse",
      "UpdateBillSpecialtyResponse",
      "UpdateBillableDxCodesResponse",
      "UpdateBillableResponse",
      "UpdateBillingQueueResponse",
      "UpdateCarePlanInstructionsResponse",
      "UpdateCarePractitionerPatientRelationshipResponse",
      "UpdateCcdaViewPreferencesResponse",
      "UpdateCptMaxUnitsResponse",
      "UpdateEntityNoteAttributeValueResponse",
      "UpdateEntityNoteResponse",
      "UpdateEntityOrderResponse",
      "UpdateInPersonFollowUpResponse",
      "UpdateInsuranceCoverageAddressResponse",
      "UpdateInsuranceEffectiveAndTerminationDatesResponse",
      "UpdateLabRequestResponse",
      "UpdateMedicalImageRequestResponse",
      "UpdateMedicationAllergiesResponse",
      "UpdateMedicationGroupStatusResponse",
      "UpdatePatientInformationResponse",
      "UpdatePatientLogResponse",
      "UpdatePrescriptionResponse",
      "UpdateProcessingRuleResponse",
      "UpdateProviderDxSuggestionResponse",
      "UpdateProviderNoteResponse",
      "UpdateReferralProviderIndexResponse",
      "UpdateReferralSuggestionResponse",
      "UpdateRuleResponse",
      "UpdateScratchpadResponse",
      "UpdateTimelyFilingLimitResponse",
      "UpsertAdHocDoctorLocationShiftResponse",
      "UpsertDoctorLocationShiftResponse",
      "UpsertDoctorSettingResponse",
      "UpsertIFaxApiKeyResponse",
      "UpsertLocationStaffingLevelResponse",
      "UpsertProviderAdjustmentResponse",
      "UpsertStaffingLevelResponse",
      "UpsertStaffingLevelShiftResponse",
      "UpsertWorkflowsForCarePlanResponse",
      "ViewedActionablesResponse",
      "VoidClaimResponse",
      "VoidOrganizationInvoiceCheckOrACHPaymentResponse",
      "WaivePatientResponsibilityResponse",
      "WriteOffBillResponse",
    ],
    Node: [
      "AddressEntity",
      "Appointment",
      "AppointmentReason",
      "ApptContractedPayer",
      "ApptReason",
      "ApptSharedResult",
      "ApptStepSkip",
      "AssignablePermission",
      "AuditActor",
      "AuditEntity",
      "AuditLog",
      "AutomatedFollowUp",
      "BatchPayment",
      "BatchPaymentClaim",
      "BatchPaymentClaimSearchResult",
      "BatchRefund",
      "BatchRefundClaim",
      "BatchRefundClaimSearchResult",
      "Bill",
      "BillExecutionJob",
      "BillLock",
      "BillNote",
      "BillRefund",
      "BillStatusChange",
      "BillTag",
      "Billable",
      "BillingQueue",
      "BillingTeam",
      "BillingUser",
      "BookAppointmentActionable",
      "BookableLocation",
      "BookableLocationAddress",
      "BookableLocationImage",
      "CancelPrescriptionRequest",
      "CancelPrescriptionResponse",
      "CarbyActionLabTestSuggestionItem",
      "CarbyActionRxSuggestionItem",
      "CarbyActionSuggestion",
      "CardScansAndMedicalImage",
      "CareGapGroup",
      "CareGapItem",
      "CarePlan",
      "CarePractitioner",
      "CarePractitionerImage",
      "CarePractitionerPatientRelationship",
      "Carrier",
      "Case",
      "CaseReport",
      "CcdaViewPreference",
      "CodeResult",
      "CompleteHPIActionable",
      "CompleteLoggingActionable",
      "Condition",
      "ConsentForm",
      "Consumer",
      "ContractedPayer",
      "ContractedPayerCoverageDetail",
      "CovidHomeTestKitOrder",
      "CovidTest",
      "CptMaxUnits",
      "Device",
      "Diagnosis",
      "DiagnosisStatus",
      "Doctor",
      "DoctorLocationShift",
      "Document",
      "DrugAdministration",
      "DrugForm",
      "DrugName",
      "DrugPackaging",
      "DrugRoute",
      "DrugStrength",
      "EcqmExport",
      "EcqmImport",
      "EducationalMaterial",
      "EducationalMaterialActionable",
      "Employee",
      "EntityMacro",
      "EntityMedicalSchema",
      "EntityNote",
      "EntityOrder",
      "FilledPrescription",
      "FollowUpAppointmentActionable",
      "Form",
      "FrozenSchema",
      "GenericActionable",
      "HealthConcern",
      "HealthInsurance",
      "ICD10Code",
      "Image",
      "ImportedDrugAdministration",
      "InPersonFollowUp",
      "Installment",
      "InsuranceCardScan",
      "InsuranceClaim",
      "InsuranceEligibilityResponse",
      "LabRequest",
      "LabResult",
      "LabResultObservation",
      "LabResultReport",
      "LabTest",
      "LabTestPanel",
      "Location",
      "LocationStaffingLevel",
      "LocationStaffingLevelSchedule",
      "LoggingEntity",
      "MDEntity",
      "MDEvent",
      "Material",
      "Measure",
      "MeasureResult",
      "MediaItem",
      "MedicalDocument",
      "MedicalImage",
      "MedicalImageRequest",
      "MedicalImageRequestResult",
      "MedicalInsurance",
      "MedicalSchema",
      "MedicalSchemaAttribute",
      "MedicalSchemaChoice",
      "MedicalSchemaChoiceGroup",
      "MedicalSchemaEntity",
      "Medication",
      "MedicationAllergy",
      "MedicationAllergyRecord",
      "MedicationGroup",
      "MedicationGroupStatus",
      "MedicationReaction",
      "MedicationStatus",
      "Message",
      "MessageThread",
      "MultiplePaymentRequest",
      "NDC",
      "NDCToDrugPackaging",
      "NearbyClinic",
      "NonProcessingRule",
      "NumeratorRule",
      "OrderDxAssociation",
      "OrderableLabTest",
      "Organization",
      "OrganizationAdmin",
      "OrganizationAdminUser",
      "OrganizationGroup",
      "OrganizationInvoice",
      "OrganizationInvoiceWithPeriod",
      "OrganizationMember",
      "OtherInsurance",
      "Patient",
      "PatientCareGapItem",
      "PatientCareGapItemRecord",
      "PatientIdentificationCardScan",
      "PatientLog",
      "PatientPayment",
      "PatientUser",
      "PayBillActionable",
      "Payment",
      "PaymentMethod",
      "PaymentReport",
      "PaymentReportItem",
      "PaymentReportItemAdjustment",
      "Permission",
      "Pharmacy",
      "Practice",
      "PracticeAppointmentReason",
      "PracticeAppointmentReasonSpecialty",
      "PractitionerContactInfo",
      "Prescription",
      "PrescriptionChangeRequest",
      "PrescriptionChangeResponse",
      "PrescriptionRenewalRequest",
      "PrescriptionRenewalResponse",
      "Problem",
      "ProcessingRule",
      "ProcessingRuleCheckpoint",
      "ProcessingRuleDailyMetric",
      "ProductOperateUser",
      "ProviderAdjustment",
      "ProviderDxSuggestion",
      "ProviderUser",
      "PublicImage",
      "ReferralActionable",
      "ReferralRequest",
      "ReferralRequestSendAttempt",
      "ReferralSuggestion",
      "RegionalPractitioner",
      "ReportedMedication",
      "Route",
      "RuleConditionGeneration",
      "RuleExecution",
      "RxFillActionable",
      "SchemaJson",
      "Scratchpad",
      "SdohCondition",
      "SearchRegion",
      "Signature",
      "Specialty",
      "SpecimenContainer",
      "StaffingLevel",
      "StaffingLevelShift",
      "StaffingRole",
      "SuggestedPrescription",
      "SuggestedPrescriptionDetails",
      "TimelyFilingLimit",
      "TreatmentPlan",
      "TreatmentPlanMacro",
      "UnauthenticatedBill",
      "UnauthenticatedFailedCharge",
      "UnauthenticatedInsurance",
      "UnauthenticatedPatient",
      "UnauthenticatedPayment",
      "UnauthenticatedRefund",
      "UnauthenticatedUser",
      "User",
      "UserGroup",
      "Vaccine",
      "Vitals",
      "Workflow",
      "WriteOff",
      "WriteOffReason",
    ],
    NotifyPatientForBillError: ["Unauthorized", "UnsupportedNotifyPatientForBillNotificationType"],
    PauseBillError: ["BillNotFound", "IllegalBillState", "InvalidBillStatusReason", "Unauthorized"],
    PostDmePaymentResult: ["PostDmePaymentErrorResult", "PostDmePaymentSuccessResult"],
    PostDmePaymentsFromUploadInnerResponse: [
      "PostDmePaymentsParserErrorResponse",
      "PostDmePaymentsResultResponse",
    ],
    PostRpmBillingFromUploadInnerResponse: [
      "PostRpmBillingParserErrorResponse",
      "PostRpmBillingResultResponse",
    ],
    PostRpmBillingResult: ["PostRpmBillingErrorResult", "PostRpmBillingSuccessResult"],
    Practitioner: ["CarePractitioner"],
    ReorderBillInsurancesError: ["BillNotFound", "InvalidBillInsuranceOrdering", "Unauthorized"],
    ReverseBillWriteOffError: [
      "IllegalBillState",
      "StatusUpdateFailedForBill",
      "Unauthorized",
      "WriteOffNotFound",
    ],
    ReverseCaseRateError: ["IllegalBillState", "InvalidCaseRate", "Unauthorized"],
    RpmBillingParserErrorContainer: [
      "RpmBillingParserCSVLevelError",
      "RpmBillingParserRowLevelError",
    ],
    RuleConditionV2: ["RuleFilterCondition", "RuleQueryCondition"],
    RuleV2: ["NonProcessingRule", "ProcessingRule"],
    Transaction: ["BillRefund", "PatientPayment", "PaymentReport", "WriteOff"],
    UnlockBillError: ["BillLockNotFound", "Unauthorized"],
    UnpauseBillError: ["BillNotFound", "IllegalBillState", "Unauthorized"],
    UpdateBillPlaceOfServiceError: ["BillNotFound", "InvalidPlaceOfServiceCode", "Unauthorized"],
    UpdateBillSpecialtyError: ["BillNotFound", "InvalidSpecialty", "Unauthorized"],
    UpdateCptMaxUnitsError: ["CptMaxUnitsNotFound", "InvalidCptMaxUnitsInput", "Unauthorized"],
    UpdateInsuranceCoverageAddressError: [
      "AddressNotBelongToPatient",
      "InsuranceCoverageOrAddressNotFound",
      "Unauthorized",
    ],
    UpdateInsuranceEffectiveAndTerminationDatesError: [
      "InsuranceCoverageNotFound",
      "InvalidEffectiveOrTerminationDate",
      "Unauthorized",
    ],
    UpdateProcessingRuleError: [
      "InvalidProcessingRuleCondition",
      "InvalidRuleName",
      "RuleNotFound",
      "Unauthorized",
    ],
    UpdateProviderDxSuggestionError: [
      "InvalidProviderDxSuggestionInput",
      "ProviderDxSuggestionNotFound",
      "Unauthorized",
    ],
    UpdateTimelyFilingLimitError: [
      "InvalidTimelyFilingLimitInput",
      "TimelyFilingLimitNotFound",
      "Unauthorized",
    ],
    UserBoundary: [
      "AuthenticationError",
      "BillingUser",
      "OrganizationAdminUser",
      "PatientUser",
      "ProductOperateUser",
      "ProviderUser",
    ],
    VaccinationConsentBoundary: ["ConsentError", "CovidVaccination"],
    ValidateBillAgainstProcessingRuleConditionError: [
      "ProcessingRuleConditionValidationBillNotFound",
      "ProcessingRuleConditionValidationError",
      "ProcessingRuleConditionValidationUnexpectedError",
    ],
    WaivePatientResponsibilityError: ["ApptNotFound", "Unauthorized"],
  },
};
export default result;
